import { io } from 'socket.io-client';
import { session } from './api.js';

/**
 * Panelin anlık bağlantısı (socket.io).
 *
 * NEDEN: "sipariş geldi" ve "misafir hesabı istedi" uyarılarının 10 saniyelik
 * yoklamayı beklemesi serviste geç kalıyor — masadaki misafir garsonu bekler.
 * Doğruluk kaynağı yine HTTP + DB; soket düşerse ekranlar kendi yoklamalarıyla
 * çalışmaya devam eder (bkz. docs/ARCHITECTURE.md §5).
 *
 * Oda adını istemci SEÇMEZ: sunucu kiracıyı jetondan türetir.
 */
let sock = null;

export function connectRealtime() {
  const { token, kind } = session();
  if (kind !== 'staff' || !token) return null;
  if (sock) return sock;
  sock = io({ path: '/socket.io', auth: { token } });
  return sock;
}

export function closeRealtime() {
  sock?.close();
  sock = null;
}
